export enum ModifySelectionOptions {
    Unlimited = "unlimited",
    Exactly = "exactly",
    AtLeast = "atLeast",
    UpTo = "upTo",
    Between = "between",
}
